

export default function Footer() {


    return (
        <div className="footer-container">
            <span> William Harvey </span> 
            <span> Copyright 2025 © </span> 
            <span> All Rights Reserved</span>
        </div>
    )
}